<template>
<div class="my-company">

    <vue-headful
        title="TZ Design Box - My Company"
        description="TZ Design Box"
    />

    <div class="container">
        <div class="columns">
            <div class="column is-2 menu-vert">
                <MenuVert :currentactive="'mycompany'" />
            </div>
            <div class="column is-10" style="margin-top:25px;">
                <Breadcrumbs/>
                <hr>
                <div class="content">
                    <h2>{{ $t("my-company") }}</h2>
                    <p>{{ $t("company-all-details") }}</p>
                    <form @submit.prevent="validateBeforeSubmit">
                        <b-field grouped>
                            <b-field expanded :label="$t('name-company')"
                                :type="{'is-danger': errors.has('name1')}"
                                :message="errors.first('name1')"
                            >
                                <b-input
                                    v-model="getCurrentCompany.name1"
                                    name="name1"
                                    v-validate="'required'"
                                    :disabled="!canCreateCompanies"
                                />
                            </b-field>
                            <b-field expanded :label="$t('name2')"
                                :type="{'is-danger': errors.has('name2')}"
                                :message="errors.first('name2')">
                                <b-input v-model="getCurrentCompany.name2" name="name2" :disabled="!canCreateCompanies"/>
                            </b-field>
                        </b-field>

                        <b-field grouped>
                            <b-field expanded :label="$t('tax-number')"
                                :type="{'is-danger': errors.has('vat_number')}"
                                :message="errors.first('vat_number')">
                                <b-input v-model="getCurrentCompany.vat_number" name="vat_number" :disabled="!canCreateCompanies"/>
                            </b-field>
                            <b-field expanded :label="$t('customer-number')"
                                :type="{'is-danger': errors.has('customer_number')}"
                                :message="errors.first('customer_number')">
                                <b-input v-model="getCurrentCompany.customer_number" name="customer_number" :disabled="!canCreateCompanies"/>
                            </b-field>
                            <b-field expanded :label="$t ('auto-approve')" v-if="canCreateCompanies"
                                :type="{'is-danger': errors.has('auto_approve')}"
                                :message="errors.first('auto_approve')">
                                <b-checkbox v-model="getCurrentCompany.auto_approve">
                                </b-checkbox>
                            </b-field>
                        </b-field>

                        <b-field grouped>
                            <b-field expanded :label="$t('address1')"
                                :type="{'is-danger': errors.has('address1')}"
                                :message="errors.first('address1')">
                                <b-input v-model="getCurrentCompany.address1" name="address1" v-validate="'required'" :disabled="!canCreateCompanies" />
                            </b-field>
                            <b-field expanded :label="$t('address2')"
                                :type="{'is-danger': errors.has('address2')}"
                                :message="errors.first('address2')">
                                <b-input v-model="getCurrentCompany.address2" name="address2" :disabled="!canCreateCompanies" />
                            </b-field>
                        </b-field>

                        <b-field grouped>
                            <b-field :label="$t('zip')"
                                :type="{'is-danger': errors.has('zip')}"
                                :message="errors.first('zip')">
                                <b-input v-model="getCurrentCompany.zip" name="zip" v-validate="'required'" :disabled="!canCreateCompanies" />
                            </b-field>

                            <b-field expanded :label="$t('city')"
                                :type="{'is-danger': errors.has('city')}"
                                :message="errors.first('city')">
                                <b-input v-model="getCurrentCompany.city" name="city" v-validate="'required'" :disabled="!canCreateCompanies" />
                            </b-field>

                            <b-field :label="$t('country')"
                                :type="{'is-danger': errors.has('country')}"
                                :message="errors.first('country')">
                                <b-select v-model="getCurrentCompany.country [0]" name="country"
                                            :placeholder="$t('choice')" v-validate="'required'" :disabled="!canCreateCompanies">
                                    <option
                                        v-for="country in getCurrentCompany.country_choices"
                                        :value="country[0]"
                                        :key="country[0]">
                                        {{ country[1] }}
                                    </option>
                                </b-select>
                            </b-field>
                        </b-field>

                        <b-field :label="$t('company-parent')" expanded v-if="getCurrentCompany.parent">
                            <b-field grouped expanded>
                                <b-input disabled v-model="getCurrentCompany.parent [1]" expanded/>
                                <p class="control">
                                    <router-link
                                        class="button is-primary"
                                        :to="{name: 'change-parent'}"
                                    >{{ $t ('change') }}</router-link>
                                </p>
                            </b-field>
                        </b-field>

                        <b-field grouped>
                            <b-field v-if="imageData.length > 0">
                                <img :src="imageData" class="logo-image" />
                            </b-field>
                            <b-field v-else>
                                <img :src="getCurrentCompany.logo_image" class="logo-image" />
                            </b-field>
                            <b-field>
                                <b-upload v-model="logoImage">
                                    <a class="button is-primary">
                                        <b-icon icon="upload"></b-icon>
                                        <span>{{ $t ("new-logo", {maxSize: maxImageSize}) }}</span>
                                    </a>
                                </b-upload>
                            </b-field>
                            <div v-if="imageSize > maxImageSize">
                                {{ $t ("logo-too-big", { maxSize: maxImageSize, size : imageSize}) }}
                            </div>
                        </b-field>

                        <b-field grouped>
                            <b-field :label="$t('region')"  v-if="canCreateCompanies">
                                <b-select :value="getCurrentCompany.region_default [0]"
                                        v-if="getCurrentCompany.region_default!==null"
                                        v-model="getCurrentCompany.region [0]"
                                        :disabled="getCurrentCompany.region_choices.length <= 1"
                                        >
                                    <option
                                        v-for="region in getCurrentCompany.region_choices"
                                        :value="region[0]"
                                        :key="region[0]">
                                        {{ region[1] }}
                                    </option>
                                </b-select>
                            </b-field>

                            <b-field :label="$t('discount-group')"  v-if="canCreateCompanies">
                                <b-select :value="getCurrentCompany.discount_group_default [0]"
                                        v-if="getCurrentCompany.discount_group_default!==null"
                                        v-model="getCurrentCompany.discount_group [0]"
                                        :disabled="getCurrentCompany.discount_group_choices.length <= 1"
                                        >
                                    <option
                                        v-for="discount in getCurrentCompany.discount_group_choices"
                                        :value="discount[0]"
                                        :key="discount[0]">
                                        {{ discount[1] }}
                                    </option>
                                </b-select>
                            </b-field>

                            <b-field :label="$t('assortment')"  v-if="canCreateCompanies">
                                <b-select :value="getCurrentCompany.assortment_default[0]"
                                        v-if="getCurrentCompany.assortment_default!==null"
                                        v-model="getCurrentCompany.assortment [0]"
                                        :disabled="getCurrentCompany.assortment_choices.length <= 1"
                                        >
                                        <option
                                        v-for="assortment in getCurrentCompany.assortment_choices"
                                        :value="assortment[0]"
                                        :key="assortment[0]">
                                        {{ assortment[1] }}
                                    </option>
                                </b-select>
                            </b-field>

                            <b-field :label="$t('language')">
                                <b-select :value="getCurrentCompany.language [0]"
                                            v-if="getCurrentCompany.language!==null"
                                            v-model="getCurrentCompany.language [0]">
                                                <option
                                        v-for="language in getCurrentCompany.language_choices"
                                        :value="language[0]"
                                        :key="language[0]">
                                        {{ language[1] }}
                                    </option>
                                </b-select>
                            </b-field>
                        </b-field>

                        <b-field :label="$t('lines')" v-if="canCreateCompanies">
                            <b-select multiple native-size="3" v-model="getCurrentCompany.lines" v-if="getCurrentCompany.line_default!==null" :value="getCurrentCompany.line_default">
                                <option
                                v-for="line in getCurrentCompany.line_choices"
                                :value="line[0]"
                                :key="line[0]">
                                    {{ line[1] }}
                                </option>
                            </b-select>
                        </b-field>

                        <b-button
                            native-type="submit"
                            type="is-primary"
                            :loading="saveCompanyActive"
                            :disabled="imageSize > maxImageSize"
                            >{{ $t("save") }}</b-button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import MenuVert             from '@/components/MenuVert'
import Breadcrumbs          from '@/components/Breadcrumbs'
import { mapGetters }       from 'vuex'

export default{
    name:'MyCompany',
    data: function(){
        return{
            test:"", iLogoImage: null, imageData: "", imageSize: 0, maxImageSize: 1
        }
    },
    components:{
        MenuVert,
        Breadcrumbs
    },
    computed: {
        ...mapGetters([
            "getCurrentCompany",
            "saveCompanyActive",
            "getCompany",
        ]),
        canCreateCompanies () {
            return this.$store.state.user.user.groups.has ("CAN_CREATE_COMPANIES")
        },
        cid: {
            get () { return this.getCompany}
        },
        logoImage: {
            get() {
                return this.iLogoImage
            },
            set (value) {
                console.log ("Update logo in preview")
                this.iLogoImage = value
                this.imageData  = ""
                var reader = new FileReader ()
                // Define a callback function to run, when FileReader finishes its job
                reader.onload = (e) => {
                    // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                    // Read image as base64 and set to imageData
                    this.imageData = e.target.result
                    this.imageSize = Math.round (e.total / 1024 / 1024 * 100) / 100
                }
                // Start the reader job - read file as a data url (base64 format)
                reader.readAsDataURL(this.logoImage)
            }
        }
    },
    methods: {
        validateBeforeSubmit() {
            var self=this
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.$store.dispatch("saveEditCompany",{self:self,company:this.cid, logo:this.logoImage})
                    .catch((error) =>{
                        self.$toastr('error', error, 'Failure');
                });
                    return;
                }
            });
        },
        loadCompanyData(cid) {
            let self = this
            this.$store.dispatch(
                "callCurrentCompany",{self:self,company:cid})

        }
    },
    created(){
        this.loadCompanyData(this.cid)
    },
    watch: {
        '$route' (to, from) {
            if (from.params.cid != to.params.cid)
                this.loadCompanyData(to.params.cid)
            }
    }
}
</script>

<style>
.my-company{
  padding-bottom:50px;
}
.content{
  background-color:#fff!important;
  padding:25px;
    box-shadow: 0 1px #FFFFFF inset, 0 1px 3px rgba(34, 25, 25, 0.4);
}
.logo-image {
    height: 80px;
}
</style>
